import React from "react";
import "../style/landing.css";
import { Container, Row, Col, Button, Card } from "react-bootstrap";

function AboutUs() {
  const ValueCard = ({ title, text, icon }) => (
    <Card className="p-4 shadow h-100">
      <Card.Body>
        <Card.Title className="text-center">
          <i className={`${icon} fs-1 mb-3 d-block`}></i>
          {title}
        </Card.Title>
        <Card.Text className="text-center">{text}</Card.Text>
      </Card.Body>
    </Card>
  );

  return (
    <>
      {/* Hero Section */}
      <section className="main-banner text-center py-5 landing-padding">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h1 className="fw-bold">About Wengmack Investment</h1>
              <p className="mt-3">
                Empowering individuals to achieve their financial dreams through 
                smart savings and investment solutions. We believe everyone deserves 
                a path to financial freedom.
              </p>
              <Button variant="primary" className="mt-3" href="/login">
                Start Your Journey <i className="bi bi-arrow-right"></i>
              </Button>
            </Col>
            <Col md={6}>
              <img
                src="/images/mainLogo.svg"
                alt="Wengmack Investment"
                className="img-fluid rounded"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Story Section */}
      <section className="py-5 bg-light landing-padding">
        <Container>
          <Row className="align-items-center">
            <Col md={12} className="text-center mb-5">
              <h2 className="fw-bold">Our Story</h2>
              <p className="mt-3">
                Wengmack Investment was founded with a simple yet powerful vision: 
                to make financial planning accessible to everyone. We understand that 
                achieving your financial goals can seem daunting, which is why we created 
                the Tajirisha program—a structured, rewarding, and flexible savings platform 
                designed to help you succeed.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={6}>
              <h3 className="fw-bold mb-3">Our Mission</h3>
              <p>
                To provide innovative and accessible financial solutions that empower 
                individuals to build wealth, secure their future, and achieve their dreams 
                through consistent saving and smart investing.
              </p>
            </Col>
            <Col md={6}>
              <h3 className="fw-bold mb-3">Our Vision</h3>
              <p>
                To be the leading financial partner for individuals seeking to transform 
                their lives through disciplined savings, strategic investments, and 
                sustainable wealth creation across East Africa and beyond.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Values Section */}
      <section className="py-5 landing-padding">
        <Container>
          <h2 className="fw-bold text-center mb-5">Our Core Values</h2>
          <Row className="g-4">
            <Col md={3}>
              <ValueCard
                title="Trust"
                text="We build lasting relationships through transparency, integrity, and reliable service."
                icon="bi bi-shield-check"
              />
            </Col>
            <Col md={3}>
              <ValueCard
                title="Innovation"
                text="We leverage technology to create simple, effective financial solutions for everyone."
                icon="bi bi-lightbulb"
              />
            </Col>
            <Col md={3}>
              <ValueCard
                title="Empowerment"
                text="We believe in equipping our clients with the tools and knowledge to succeed financially."
                icon="bi bi-graph-up-arrow"
              />
            </Col>
            <Col md={3}>
              <ValueCard
                title="Excellence"
                text="We are committed to delivering exceptional service and results for our clients."
                icon="bi bi-award"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* What We Offer Section */}
      <section className="py-5 bg-light landing-padding">
        <Container>
          <h2 className="fw-bold text-center mb-5">What We Offer</h2>
          <Row className="g-4 mb-4">
            <Col md={4}>
              <ValueCard
                title="Bamba Plan"
                text="This is your go-to solution to achieve your lifestyle goals in just 12 Months. Perfect for saving toward Birthdays, Vacations, Electronics, and Household Items."
                icon="bi bi-person"
              />
            </Col>
            <Col md={4}>
              <ValueCard
                title="Imarika Plan"
                text="Ideal for short term financial goals. Perfect for individuals looking to grow their wealth, start a business, or achieve specific financial milestones within 12 - 36 Months."
                icon="bi bi-people"
              />
            </Col>
            <Col md={4}>
              <ValueCard
                title="Milele Plan"
                text="Ideal for your long term financial goals. Suitable for individuals planning to buy a car, own a piece of land or build a home in 36 to 180 months."
                icon="bi bi-building"
              />
            </Col>
          </Row>
          <Row className="g-4">
            <p>Under the Imarika plan, i.e 12 - 36 month plan, we have:</p>
            <Col md={4}>
              <ValueCard
                title="Anza Biz"
                text="We have one goal in mind: Financially Empowering our Clients. Save & Start your side hustle in 18 months."
                icon="bi bi-briefcase"
              />
            </Col>
            <Col md={4}>
              <ValueCard
                title="ToToTajiri"
                text="It's about preparing your child for life. Our ToToTajiri empowers you to secure long-term financial stability for your children beyond education. With flexible plans, you can build a fund that grows over time."
                icon="bi bi-graph-up"
              />
            </Col>
            <Col md={4}>
              <ValueCard
                title="WEMA Fund"
                text="Wema Fund is a personalized financial solution designed to help clients grow and preserve their wealth through expertly tailored wealth management strategies."
                icon="bi bi-bank"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* WEMA Fund Detailed Section */}
      <section className="py-5 landing-padding">
        <Container>
          <Row className="mb-5">
            <Col md={12} className="text-center">
              <h2 className="fw-bold mb-4">WEMA FUND</h2>
              <p className="lead">
                Wema Fund is a personalized financial solution designed to help clients grow and 
                preserve their wealth through expertly tailored wealth management strategies.
              </p>
            </Col>
          </Row>

          {/* Objectives */}
          <Row className="mb-5">
            <Col md={12}>
              <h3 className="fw-bold mb-4">Objectives for WEMA:</h3>
            </Col>
            <Col md={6} className="mb-3">
              <div className="d-flex align-items-start">
                <i className="bi bi-arrow-up-circle-fill text-primary fs-4 me-3"></i>
                <div>
                  <h5 className="fw-bold">Capital Growth</h5>
                  <p>The primary objective of Wema fund is to offer above average market returns of up to 20% p.a. for our clients.</p>
                </div>
              </div>
            </Col>
            <Col md={6} className="mb-3">
              <div className="d-flex align-items-start">
                <i className="bi bi-shield-check text-primary fs-4 me-3"></i>
                <div>
                  <h5 className="fw-bold">Capital Preservation</h5>
                  <p>Wema Fund will safeguard client's wealth through disciplined risk management and diversified investments.</p>
                </div>
              </div>
            </Col>
            <Col md={6} className="mb-3">
              <div className="d-flex align-items-start">
                <i className="bi bi-sliders text-primary fs-4 me-3"></i>
                <div>
                  <h5 className="fw-bold">Flexibility</h5>
                  <p>Offer tailormade investment plans to suit different risk profiles and financial goals for our clients.</p>
                </div>
              </div>
            </Col>
            <Col md={6} className="mb-3">
              <div className="d-flex align-items-start">
                <i className="bi bi-eye text-primary fs-4 me-3"></i>
                <div>
                  <h5 className="fw-bold">Transparency</h5>
                  <p>Maintain high standards of transparency, governance and client communication.</p>
                </div>
              </div>
            </Col>
          </Row>

          {/* Targeted Returns */}
          <Row className="mb-5 bg-light p-4 rounded">
            <Col md={12}>
              <h3 className="fw-bold mb-3">Targeted Returns</h3>
              <p>We target a return of <strong>20% p.a.</strong> for our <strong>Fahari Plan</strong> and <strong>16.8% p.a.</strong> for our <strong>Imara Plan</strong>.</p>
              <p className="text-muted fst-italic">*Please note, this is a projected return and not a guarantee.</p>
            </Col>
          </Row>

          {/* Strategic Asset Allocation */}
          <Row>
            <Col md={12}>
              <h3 className="fw-bold mb-4">Strategic Asset Allocation</h3>
              <p className="mb-4">
                The fund strategically invests across key local and global markets, including:
              </p>
            </Col>
            <Col md={12}>
              <Row className="g-3">
                <Col md={4}>
                  <div className="p-3 border rounded h-100">
                    <i className="bi bi-building text-primary fs-4 me-2"></i>
                    <strong>Private Equity (PE)</strong>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="p-3 border rounded h-100">
                    <i className="bi bi-file-earmark-text text-primary fs-4 me-2"></i>
                    <strong>Corporate and Sovereign Bonds</strong>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="p-3 border rounded h-100">
                    <i className="bi bi-bar-chart text-primary fs-4 me-2"></i>
                    <strong>Equities</strong>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="p-3 border rounded h-100">
                    <i className="bi bi-currency-exchange text-primary fs-4 me-2"></i>
                    <strong>Foreign Exchange</strong>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="p-3 border rounded h-100">
                    <i className="bi bi-graph-up-arrow text-primary fs-4 me-2"></i>
                    <strong>Exchange Traded Funds (ETFs)</strong>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="p-3 border rounded h-100">
                    <i className="bi bi-coin text-primary fs-4 me-2"></i>
                    <strong>Derivative Instruments</strong>
                    <small className="d-block text-muted">(metals, commodities, currencies, futures, options)</small>
                  </div>
                </Col>
              </Row>
              <p className="mt-4">
                This diversified approach aims to capture broad market dynamics and optimize 
                risk-adjusted returns across multiple asset classes.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-5 bg-light landing-padding">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="landing-opt-left">
              <h2 className="fw-bold mb-4">What we Offer</h2>
              <div className="mb-4">
                <h5 className="fw-bold">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Flexible Savings Plans
                </h5>
                <p>Start with as little as 150 bob per week and customize your plan to fit your goals.</p>
              </div>
              <div className="mb-4">
                <h5 className="fw-bold">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Rewarding System
                </h5>
                <p>Earn Tajirisha points with every contribution—every 50 bob you save earns you 1 point.</p>
              </div>
              <div className="mb-4">
                <h5 className="fw-bold">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  24/7 Support
                </h5>
                <p>Our dedicated team is always available to help you stay on track and reach your goals.</p>
              </div>
              <div className="mb-4">
                <h5 className="fw-bold">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Track Your Progress
                </h5>
                <p>Use our intuitive dashboard to monitor your savings, view milestones, and visualize your success.</p>
              </div>
            </Col>
            <Col md={6}>
              <img
                src="/images/image8.png"
                alt="Dashboard Features"
                className="rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Call to Action Section */}
      <section className="text-center py-5 landing-padding">
        <Container>
          <h2 className="fw-bold mb-3">Ready to Start Your Financial Journey?</h2>
          <p className="mb-4">
            Join thousands of individuals who are already building their financial future with Wengmack Investment.
          </p>
          <Button variant="primary" size="lg" href="/signup">
            Get Started Today <i className="bi bi-arrow-right"></i>
          </Button>
        </Container>
      </section>
    </>
  );
}

export default AboutUs;
